import { useState, useEffect } from 'react';

import SearchBar from '../searchBar/SearchBar';
import SideMenu from "../sideMenu/SideMenu";
import List from "../list/List";
import Line from "../line/Line";

import { WORKSPACE_ID, PROJECT_ID, PER_PAGE } from '../constants';

import './dashBoard.css';

const DashBoard = ({ token }) => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [projectInfo, setProjectInfo] = useState({ tree: {}, types: {}});

    const getMetaData = async () => {
        fetch(`https://invadmin.officescheme.ru/project/${WORKSPACE_ID}/${PROJECT_ID}/API?action=meta_and_tree`, {
            method: 'POST',
            headers: {
                'x-ws-common-auth': token
            }
        })
        .then(result => result.json())
        .then(result => {
            const tree = {};
            const newTypes = {};

            const getLocations = (children, parent) => {
                children.forEach(child => {
                    if (!parent) tree[child.id] = child.name;
                    else tree[child.id] = `${parent} ${child.name}`;

                    if (child.childs.length) {
                        if (parent) getLocations(child.childs, `${parent} ${child.name}`);
                        else getLocations(child.childs, `${child.name}`);
                    }
                });

                return tree;
            };

            const typesAndLocations = { tree: getLocations(result.tree, '') };
            
            result = result.metablock.nodes;

            for (let type in result) {
                const fields = {};

                const fieldsArray = result[type].plugin_data;

                for (let field in fieldsArray) {
                    fieldsArray[field].fields.forEach(subField => {
                        fields[`f_${field}_${subField.id}`] = subField.name;
                    });
                }

                newTypes[type] = { checked: true, name: result[type].name, id: type, fields };
            };

            typesAndLocations.types = newTypes;

            setProjectInfo(typesAndLocations);
        });
    };

    const getObjects = async () => {
        const formData = new FormData();
    
        formData.append('perpage', PER_PAGE);
        formData.append('page', page - 1);
        formData.append('sortColumn', 'id');
        formData.append('sortDirection', 0);

        fetch(`https://invadmin.officescheme.ru/project/${WORKSPACE_ID}/${PROJECT_ID}/API?action=node_list`, {
            method: 'POST',
            headers: {
                'x-ws-common-auth': token
            },
            body: formData
        })
        .then(result => result.json())
        .then(result => {
            const data = [];

            result.items.forEach(object => {
                const fields = {};

                for(let field in projectInfo.types[object.type_uid].fields) {
                    fields[field] = object[field];
                }

                const processedObject = { id: object.id, type: object.type_name, number: object.name, location: projectInfo.tree[object.parent], typeObject: object.type_uid, fields };

                data.push(processedObject);
            });

            setTotal(result.total);
            setData(data);
        });
    };

    useEffect(() => {
        getMetaData();
    }, []);

    useEffect(() => {
        getObjects();
    }, [page, projectInfo.tree]);

    return (
        <div className="dashBoard">
            <SearchBar projectInfo={projectInfo} token={token}/>
            <div className="infoTable">
                <SideMenu projectInfo={projectInfo} token={token}/>
                <Line />
                <List data={data} page={page} setPage={setPage} total={total} getObjects={getObjects} projectInfo={projectInfo}/>
            </div>
        </div>
    );
};

export default DashBoard;